import { render, staticRenderFns } from "./danCi.vue?vue&type=template&id=40a563ae&scoped=true&"
import script from "./danCi.vue?vue&type=script&lang=js&"
export * from "./danCi.vue?vue&type=script&lang=js&"
import style0 from "./danCi.vue?vue&type=style&index=0&id=40a563ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a563ae",
  null
  
)

export default component.exports